<template>
  <v-container fluid class="px-0 py-0">
    <v-card flat>
      <v-row>
        <v-col>
          <v-container fluid>
            <v-tabs v-model="tab">
              <v-tab v-for="item in items" :key="item.id">
                {{ item.name }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="item in items" :key="item.id">
                <custom-data-type-records
                  :owner-id="ownerId"
                  :custom-data-type-id="item.id"
                ></custom-data-type-records>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-col>
      </v-row>

      <v-row v-if="debug">
        <v-col>
          <code>{{ ownerId }}</code>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import CustomDataTypeRecords from "./CustomDataTypeRecords.vue";
const CDATA_TYPES_QUERY = gql`
  query ownerDataTypes($owner: String) {
    customDataTypes(filter: { owner_eq: $owner }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
export default {
  components: { CustomDataTypeRecords },
  name: "custom-data-types",
  props: {
    owner: {
      type: String,
      default: () => "",
    },
    ownerId: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      debug: false,
      tab: null,
    };
  },

  apollo: {
    items: {
      query: CDATA_TYPES_QUERY,
      variables() {
        return {
          owner: this.owner,
        };
      },
      skip() {
        return !this.owner;
      },
      update: (data) => {
        return data.customDataTypes.edges.map(removeGQLTypename);
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/custom-data-types/CustomDataTypes.vue